var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"image__wrapper",class:{'blurry-vision' : _vm.lowResSrc !== ''}},[_c('loader'),_c('img',{staticClass:"image__item",class:_vm.imageClass,style:(_vm.imageStyle),attrs:{"src":_vm.lowResSrc,"data-url":_vm.src,"width":_vm.width,"height":_vm.height,"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }